import React, {Component} from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import NoSsr from "@material-ui/core/NoSsr";
import LayersIcon from "@material-ui/icons/LayersOutlined";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import {layerMenu} from "../../constants/edit-menu";
import {withStyles} from "@material-ui/core/styles";

const styles = {
  root: {
    padding: `12px 2px 12px 8px`,
    borderRadius: `3px`
  }
};

class Edit extends Component {
  static propTypes = {
    toggleEffect: PropTypes.func,
    selected: PropTypes.object,
    classes: PropTypes.object
  };
  state = {
    anchorEl: null
  };
  handleClick = (event) => {
    this.setState({anchorEl: event.currentTarget});
  };
  handleClose = () => {
    this.setState({anchorEl: null});
  };
  render() {
    const {anchorEl} = this.state;
    const {selected, classes} = this.props;
    return (
      !!selected && (
        <NoSsr>
          <div className="panel-control__item">
            <Tooltip title="Правка">
              <div>
                <IconButton
                  aria-owns={anchorEl ? `edit-menu` : void 0}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                  classes={{root: classes.root}}
                >
                  <LayersIcon />
                  <ArrowDropDownIcon />
                </IconButton>
              </div>
            </Tooltip>
            <Menu
              id="edit-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={this.handleClose}
            >
              {layerMenu.map((item) => {
                const {name, icon, handleClick, hotKey} = item;
                return (
                  <MenuItem
                    key={name}
                    onClick={() => {
                      handleClick();
                      this.handleClose();
                    }}
                  >
                    <span className="context-menu-item__content">
                      {icon && (
                        <i className={`context-menu-item__icon ${icon}`} />
                      )}
                      <span className="context-menu-item__text">{name}</span>
                    </span>
                    {hotKey && (
                      <span className="context-menu-item__hot-key">
                        {hotKey}
                      </span>
                    )}
                  </MenuItem>
                );
              })}
            </Menu>
          </div>
        </NoSsr>
      )
    );
  }
}

export default withStyles(styles)(Edit);
